<script setup>
defineProps({
  copyright: {
    type: String,
    default: () => '',
  },
  privacy: {
    type: Object,
    default: () => {},
  },
  developedBy: {
    type: Object,
    default: () => {},
  },
  designedBy: {
    type: Object,
    default: () => {},
  },
});
</script>

<template>
  <div
    v-if="copyright || privacy || developedBy || designedBy"
    class="footer__bottom"
  >
    <div
      v-if="
        (privacy && (privacy.title || privacy.text)) ||
        (copyright && (copyright.start || copyright.text))
      "
      class="footer__left"
    >
      <div
        v-if="privacy && (privacy.title || privacy.text)"
        class="footer__privacy"
      >
        <CTagDetect
          v-if="privacy.url"
          :to="privacy.url"
          class="footer__privacy-item footer-link body-3-regular"
          >{{ privacy.title }}</CTagDetect
        >
        <p
          v-else
          class="mb-0 footer__privacy-item footer-link body-3-regular"
          v-html="privacy.title"
        ></p>
      </div>

      <div
        v-if="copyright && (copyright.start || copyright.text)"
        class="footer__copyright footer-copyright body-3-regular"
      >
        <p class="mb-0">
          © {{ copyright.start }}-{{ new Date().getFullYear() }}
          {{ copyright.text }}
        </p>
      </div>
    </div>
    <div
      v-if="
        (developedBy && (developedBy?.logo?.src || developedBy?.url)) ||
        (designedBy &&
          ((designedBy && designedBy?.logo?.src) || designedBy?.url))
      "
      class="footer__right"
    >
      <div
        v-if="developedBy && (developedBy?.logo?.src || developedBy?.url)"
        class="footer__developed footer-link body-3-regular"
      >
        {{ $t('footer.development') }}
        <CTagDetect :to="developedBy.url" target="_blank">
          <NuxtImg
            v-if="developedBy?.logo?.src"
            :src="developedBy?.logo?.src"
            :alt="developedBy?.logo?.alt"
            :height="developedBy?.logo?.height"
            :width="developedBy?.logo?.width"
            class="footer__developed-image"
            loading="lazy"
          />
        </CTagDetect>
      </div>
      <div
        v-if="designedBy && (designedBy?.logo?.src || designedBy?.url)"
        class="footer__developed footer-link body-3-regular"
      >
        {{ $t('footer.design') }}
        <CTagDetect :to="designedBy.url" target="_blank">
          <NuxtImg
            v-if="designedBy?.logo?.src"
            :src="designedBy?.logo?.src"
            :alt="designedBy?.logo?.alt"
            :height="designedBy?.logo?.height"
            :width="designedBy?.logo?.width"
            class="footer__developed-image"
            loading="lazy"
          />
        </CTagDetect>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.footer {
  &__bottom {
    align-items: end;
    border-top: 1px solid $divider;
    display: grid;
    gap: 16px;
    grid-template-columns: minmax(calc(43% - 8px), max-content) minmax(
        calc(57% - 8px),
        max-content
      );
    justify-content: space-between;
    padding-top: 31px;
    @include media-breakpoint-up(sm) {
      align-items: center;
      gap: 24px;
      grid-template-columns: auto auto;
      padding-top: 41px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-top-width, 1);
      @include responsive-spacing(gap, 24);
      @include responsive-spacing(padding-top, 41);
    }
  }
  &__left {
    display: flex;
    flex-direction: column;
    gap: 24px;
    @include media-breakpoint-up(sm) {
      align-items: center;
      gap: 24px;
      flex-direction: row;
    }
    @include media-breakpoint-up(md) {
      gap: 40px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 40);
    }
  }
  &__privacy {
    grid-area: privacy;
    @include media-breakpoint-up(sm) {
      order: 2;
    }
    &-item {
      color: $on-surface-variant;
    }
  }
  &__copyright {
    color: $on-surface-variant;
    @include media-breakpoint-up(sm) {
      order: 1;
    }
  }
  &__right {
    display: flex;
    flex-direction: column;
    @include media-breakpoint-up(sm) {
      flex-direction: row;
      gap: 16px;
      justify-content: flex-end;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 16);
    }
  }
  &__developed {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: end;
    @include media-breakpoint-up(md) {
      gap: 8px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 8);
    }
    &-image {
      margin: 0 auto;
    }
  }
}
</style>
